import { environment } from '@lla-platform/core/core-util'

export const FLUIDS_API_URL = {
  fluidsSummary: `${environment.apiUrl}/fluids/summary`,
  exportFluidsSummary: `${environment.apiUrl}/fluids/summary/export`,

  fluidsList: `${environment.apiUrl}/fluids/filters`,
  exportFluidsList: `${environment.apiUrl}/fluids/filter/export`
}
